import React from 'react';
import {any, oneOfType, element, bool, string, func, arrayOf, object} from 'prop-types';
import {Form, Label, Grid, Icon} from "semantic-ui-react";
import {FormattedMessage} from "react-intl";
import {Tooltip} from 'react-tippy';

const TextInputWithTooltip = props => {
  const label = props.label && (
    <Grid.Row className='db-field-label-row'>
      <Label basic className='db-field-label'>
        {props.required && <i className='icon asterisk inline required' />}
        {props.label}
      </Label>
    </Grid.Row>
  );

  const input = (
    <Form.Input
      type='text'
      name={props.name}
      error={props.errors.length > 0}
      required={props.required}
      value={props.value}
      onBlur={(event) => props.onValueChanged(event.target.value, true)}
      onChange={(event, data) => props.onValueChanged(data.value, false)}
      helperText={props.helperText} />
  );

  const errors = props.errors.map(error => (
    <Label key={error.type} basic className='db-error-label'>
      <FormattedMessage id={`errors.validation.${error.type}`}/>&nbsp;
      {error.invalidValues && (
        <FormattedMessage id='errors.validation.invalid_values' values={{invalidValues: error.invalidValues}}/>
      )}
    </Label>
  ));

  const tooltip = props.helpContent && (
    <Grid.Column width={1} verticalAlign='middle' className='db-tooltip'>
      <div className='popup-scroll-container'>
        <Tooltip
          html={(
            <div style={{maxWidth: '635px', maxHeight: '600px', overflow: 'auto'}}>
              {props.helpContent}
            </div>
          )}
          arrow={true}
          position='left'
          theme='light'
          trigger='click'>
          <Icon color='blue' name='info circle'/>
        </Tooltip>
      </div>
    </Grid.Column>
  );

  return (
    <Grid columns='equal'>
      {label}
      <Grid.Row className='db-field-input-row'>
        <Grid.Column className='db-field-input-wrapper'>
          {input}
          {errors}
        </Grid.Column>
        {tooltip}
      </Grid.Row>
    </Grid>
  );
};

TextInputWithTooltip.propTypes = {
  label: oneOfType([string, element, object]),
  helpContent: oneOfType([string, element, object]),
  value: any.isRequired,
  required: bool,
  name: string.isRequired,
  onValueChanged: func.isRequired,
  errors: arrayOf(object)
};

TextInputWithTooltip.defaultProps = {
  errors: []
};

export default TextInputWithTooltip;



// WEBPACK FOOTER //
// ./public/components/forms/BasicFormFields/TextInputWithTooltip.jsx